export default "__VITE_ASSET__DAa1N_5P__"